export default "__VITE_ASSET__D2XUAf2i__"